import dynamic from 'next/dynamic';
import { MessageProps } from './SuccessMessage.types';

export const SuccessMessageMGP = dynamic<MessageProps>(() =>
  import('./SuccessMessage').then(module => module.SuccessMessage)
);
